import { combineReducers } from 'redux';
import Settings from './Settings';
import PCOEvents from './PCOEvents';
import ccb from './ccb';
import Groups from './Groups';
import Prayer from './Prayer';
import Announcements from './Announcements';
import RSSReader from './rssreader';
import Podcasting from './Podcasting';
import Events from './Events';
export default combineReducers({
    Settings,
    PCOEvents,
    Groups,
    Prayer,
    Announcements,
    ccb,
    RSSReader,
    Podcasting,
    Events
});
